export const CopyrightFooter = () => (
  <div className='copyright-footer tiny-text'>
    <div className='privacy-policy-wrapper'>
      <a className='privacy-policy-text' onClick={() => window.open('https://www.yembo.ai/legal/privacy-policy')}>
        Privacy Policy
      </a>
      <span className='separator' />
    </div>
    <span>&copy; {new Date().getFullYear()} Yembo, Inc.</span>
  </div>
);
